import api from './api'

export const promotionsService = {
  getAll: async (params = {}) => {
    const res = await api.get('/promotions', { params })
    return res.data
  },

  getById: async (id) => {
    const res = await api.get(`/promotions/${id}`)
    return res.data.data
  },

  create: async (data) => {
    const res = await api.post('/promotions', data)
    return res.data.data
  },

  update: async (id, data) => {
    const res = await api.patch(`/promotions/${id}`, data)
    return res.data.data
  },

  delete: async (id) => {
    await api.delete(`/promotions/${id}`)
  },
}
